<script lang="ts">
  import { ServiceFactory } from '@/services/ServiceFactory'
  import TableContainer from '@/components/TableContainer.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'InteractionAverageWidget',
    components: { TableContainer },
    props: {
      id: Number,
      cycleId: Number,
    },

    data() {
      return {
        stats: [],
        loading: true,
      }
    },

    computed: {
      average() {
        if (!this.stats?.average) return 0

        if (this.isInt(this.stats.average)) return this.stats.average

        return this.stats.average.toFixed(1)
      },
    },

    watch: {
      cycleId() {
        this.update()
      },
    },

    async beforeMount() {
      this.update()
      this.loading = false
    },

    methods: {
      isInt(n) {
        return n % 1 === 0
      },
      update() {
        ServiceFactory.createStatisticsService()
          .interactionAverage(this.id, this.cycleId)
          .then((response) => (this.stats = response.data))
      },
    },
  })
</script>

<template>
  <TableContainer v-if="!loading" class="interaction-average-widget">
    <table>
      <tbody>
        <tr>
          <td>Interacties</td>
          <td>{{ stats.total }}</td>
        </tr>

        <tr>
          <td>Field days</td>
          <td>{{ stats.distinct }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td>
            <strong>Gemiddeld aantal bezoeken per field day:</strong>
          </td>

          <td>{{ average }}</td>
        </tr>
      </tfoot>
    </table>
  </TableContainer>
</template>
